import * as Sentry from "@sentry/react";
import React from "react";
import { createRoot } from "react-dom/client";

import AppRouter from "./AppRouter";
import environment from "./envConfig";
import registerServiceWorker from "./serviceWorker";

import "./utils/polyfills/append"; // IE11: error triggered when we export the canvas.
import "abortcontroller-polyfill/dist/abortcontroller-polyfill-only";
import "./i18n";

Sentry.init(environment.sentry);

if (environment.app.pwaActive) {
  registerServiceWorker();
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<AppRouter />);
